import "./Message.css";

const Message = ({ message }) => {
  return <h5 className="message">{message}</h5>;
};

export default Message;
